 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"styles","11":"vendors~Header~about~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotels~modern_deskto~b89c92da","12":"vendors~Header~about~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desk~26e1b5f5","15":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","16":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","18":"vendors~AuthNew~Cigarette~ClientFormContainer~client~hotels~order~order_changing_request~sbp~search~~f81c4273","19":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","23":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","24":"Header~alfa_pay~gift_certificate~pay_card~sbp~t_pay","26":"vendors~AuthNew~Cigarette~ClientFormContainer~modern_desktop_home~modern_mobile_home~tinkoff_iframe","28":"vendors~Header~about~faq~header_app","30":"vendors~Cigarette~EmptySearch~tinkoff_iframe","31":"vendors~Cigarette~HotelNotice~tinkoff_iframe","32":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","33":"vendors~Header~about~header_app","35":"AuthNew~ClientFormContainer","36":"FiltersPanel","37":"Map~YandexMapsSearch","38":"vendors~AuthNew~ClientFormContainer","39":"vendors~Cigarette~tinkoff_iframe","40":"AboutRoomPopup","41":"AndroidIcon","42":"AuthNew","43":"Cigarette","44":"ClientFormContainer","45":"EmptyFiltration","46":"EmptySearch","47":"ExpensiveHotelsPopup","48":"FiltersPanelMobile","49":"FlightFail","50":"FlightsItem","51":"Header","52":"HeaderAuth","53":"HotelNotice","54":"IosIcon","55":"Map","56":"MountainsContainer","57":"NoTopHotel","58":"NpsForm","59":"OperatorsStatuses","60":"PriceChart","61":"SeamlessTBankAuth","62":"SearcherEmptyHotel","63":"SimilarPackagesContainer","64":"Subscribe","65":"ToAppgallery","66":"ToRustore","67":"YandexHotelMap","68":"YandexMapCheckout","69":"YandexMapsSearch","93":"sigmaInit","99":"vendors~AboutRoomPopup","100":"vendors~Subscribe","106":"vendors~sigmaInit"}[chunkId]||chunkId) + ".__" + {"2":"de342c40e2e9109382d3","11":"3bd816e66173f12df5ea","12":"7da62c5880a413676733","15":"59f124cbe356bbfa5536","16":"209a67a551c4853a3197","18":"232f87adc5f431b0efc9","19":"23439f4cd9f62259bb46","21":"2d063f04a3ee575849f7","23":"09ca57076d5a9464bc32","24":"7e24f782a7b13920a6bb","26":"cd78314ea791d2818206","28":"62a188359558d0ab8527","30":"24e4e6475371d3d65e80","31":"0e9d1aab9c063acc8b49","32":"2fc976624ca104e6b33b","33":"914aba2a07814bb2d75a","35":"0ace91176332a4d3ee97","36":"ab25e95130fe11ab25c7","37":"456d42a5a35e96570447","38":"df9c50ba25024c6466ee","39":"607236a401ee9c5d9d31","40":"19ff5a80b7577ccd7423","41":"28c46a962b58005f91a9","42":"652beb74a56c096079c0","43":"5fa65d1f0f6c83828509","44":"e4fc0c65356bc5f3ab78","45":"48723b8c53aecc7cd67d","46":"f4023830cc1a9d347631","47":"950f2a6401151a4f4e6d","48":"ec8f641c7e7a3c709667","49":"9368fadc9b9869363b0d","50":"9ff35c12e4bf475c2db7","51":"0e3f93aeb153168ef6c3","52":"5cf67209d823d5cf3373","53":"bc3fc182b1c472b5dad3","54":"5adcc69447c26626b174","55":"af98db7cb9d7feb3821d","56":"ffbb13ffb5ef2ad46823","57":"78237426213b83bc9b7d","58":"501eb98037710f58af79","59":"2e7d4aa0eca8fd9408d6","60":"53200ba3475f05d60771","61":"c6028abeecad40245a4b","62":"066ced70a66e2dd3afaa","63":"d13c2726c24d253def0a","64":"bab24ff58c67cd783c6f","65":"dd0219f955d1eb38c976","66":"2607bf73333384630115","67":"0a19e1b59e4b2b733d25","68":"04ca1fa024adbf77433b","69":"0635e7af48f2e7f9d1e1","93":"7f8a0872d3845352d9d7","99":"0a13c5e3ac780a568c25","100":"3211dd346a2fed5c9e24","106":"7be193375dccec072912"}[chunkId] + ".prod.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"35":1,"36":1,"37":1,"42":1,"46":1,"47":1,"49":1,"51":1,"52":1,"55":1,"57":1,"59":1,"60":1,"62":1,"67":1,"68":1,"69":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"2":"styles","11":"vendors~Header~about~alfa_pay~client~gift_certificate~header_app~hotel_checkout~hotels~modern_deskto~b89c92da","12":"vendors~Header~about~alfa_pay~client~header_app~hotel_checkout~hotel_reviews_page~hotels~modern_desk~26e1b5f5","15":"vendors~Cigarette~HeaderAuth~client~gift_certificate~hotel_checkout~hotel_reviews_page~hotels~order~~7054e58b","16":"vendors~Header~about~client~header_app~hotel_checkout~hotels~modern_desktop_home~modern_mobile_home~~0794bb2d","18":"vendors~AuthNew~Cigarette~ClientFormContainer~client~hotels~order~order_changing_request~sbp~search~~f81c4273","19":"vendors~AuthNew~ClientFormContainer~Header~about~client~header_app~modern_desktop_home~modern_mobile~8e5f7b0d","21":"authVendor","23":"vendors~Cigarette~Header~about~header_app~modern_desktop_home~modern_mobile_home~testimonials~tinkoff_iframe","24":"Header~alfa_pay~gift_certificate~pay_card~sbp~t_pay","26":"vendors~AuthNew~Cigarette~ClientFormContainer~modern_desktop_home~modern_mobile_home~tinkoff_iframe","28":"vendors~Header~about~faq~header_app","30":"vendors~Cigarette~EmptySearch~tinkoff_iframe","31":"vendors~Cigarette~HotelNotice~tinkoff_iframe","32":"vendors~Cigarette~hotel_reviews_page~tinkoff_iframe","33":"vendors~Header~about~header_app","35":"AuthNew~ClientFormContainer","36":"FiltersPanel","37":"Map~YandexMapsSearch","38":"vendors~AuthNew~ClientFormContainer","39":"vendors~Cigarette~tinkoff_iframe","40":"AboutRoomPopup","41":"AndroidIcon","42":"AuthNew","43":"Cigarette","44":"ClientFormContainer","45":"EmptyFiltration","46":"EmptySearch","47":"ExpensiveHotelsPopup","48":"FiltersPanelMobile","49":"FlightFail","50":"FlightsItem","51":"Header","52":"HeaderAuth","53":"HotelNotice","54":"IosIcon","55":"Map","56":"MountainsContainer","57":"NoTopHotel","58":"NpsForm","59":"OperatorsStatuses","60":"PriceChart","61":"SeamlessTBankAuth","62":"SearcherEmptyHotel","63":"SimilarPackagesContainer","64":"Subscribe","65":"ToAppgallery","66":"ToRustore","67":"YandexHotelMap","68":"YandexMapCheckout","69":"YandexMapsSearch","93":"sigmaInit","99":"vendors~AboutRoomPopup","100":"vendors~Subscribe","106":"vendors~sigmaInit"}[chunkId]||chunkId) + "." + {"2":"d3c7275d161b6a06c917","11":"d41d8cd98f00b204e980","12":"d41d8cd98f00b204e980","15":"d41d8cd98f00b204e980","16":"d41d8cd98f00b204e980","18":"d41d8cd98f00b204e980","19":"d41d8cd98f00b204e980","21":"d41d8cd98f00b204e980","23":"d41d8cd98f00b204e980","24":"d41d8cd98f00b204e980","26":"d41d8cd98f00b204e980","28":"d41d8cd98f00b204e980","30":"d41d8cd98f00b204e980","31":"d41d8cd98f00b204e980","32":"d41d8cd98f00b204e980","33":"d41d8cd98f00b204e980","35":"b61c63c451d3dfcb51e1","36":"bf25ac7aeb6dccbefb83","37":"44173ef29090408cf488","38":"d41d8cd98f00b204e980","39":"d41d8cd98f00b204e980","40":"d41d8cd98f00b204e980","41":"d41d8cd98f00b204e980","42":"c06fe60c4aedeea3460c","43":"d41d8cd98f00b204e980","44":"d41d8cd98f00b204e980","45":"d41d8cd98f00b204e980","46":"7bc690fbfb444b4fb1b5","47":"44a3f21ea8acc536d3ad","48":"d41d8cd98f00b204e980","49":"3d5c7660f989b289df97","50":"d41d8cd98f00b204e980","51":"771879a0ec9052a8d879","52":"e2dc08d21432f13fd3cc","53":"d41d8cd98f00b204e980","54":"d41d8cd98f00b204e980","55":"23b2d199ef07ed3b3d27","56":"d41d8cd98f00b204e980","57":"563237d543522fbcc346","58":"d41d8cd98f00b204e980","59":"a65265f17a8153dfeb55","60":"dcd01e976637fa2df2e8","61":"d41d8cd98f00b204e980","62":"75658e3d18bc8e0d0ddd","63":"d41d8cd98f00b204e980","64":"d41d8cd98f00b204e980","65":"d41d8cd98f00b204e980","66":"d41d8cd98f00b204e980","67":"05caa9d97f0d66d5cb8f","68":"05b56ebd11809d58c1e8","69":"00473b166a1965df28ba","93":"d41d8cd98f00b204e980","99":"d41d8cd98f00b204e980","100":"d41d8cd98f00b204e980","106":"d41d8cd98f00b204e980"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 3 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed after 3 retries.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          setTimeout(function() {
 				            var cacheBust = 'cache-bust=true' + retryAttemptString;
 				            var retryScript = loadScript(
 				              jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				              retries - 1
 				            );
 				            document.head.appendChild(retryScript);
 				          }, 0);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 3);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.cdn.level.travel/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpLtModules"] = window["wpJsonpLtModules"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
